import { render, staticRenderFns } from "./SelectArchetype.vue?vue&type=template&id=54951426&"
import script from "./SelectArchetype.vue?vue&type=script&lang=js&"
export * from "./SelectArchetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports